<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
    <g fill="none" fill-rule="nonzero">
        <circle cx="18" cy="18" r="18" :fill="globalColors.primary"/>
        <g fill="#FFF">
            <path d="M27.481 11.519a1.602 1.602 0 0 0-1.175-.49H9.664c-.457 0-.85.164-1.175.49A1.602 1.602 0 0 0 8 12.694v12.647c0 .458.163.85.489 1.176.326.326.718.489 1.175.489h16.642c.457 0 .85-.163 1.175-.49.326-.325.489-.717.489-1.175V12.694c0-.458-.163-.85-.489-1.175zm-.842 13.823a.32.32 0 0 1-.1.234.32.32 0 0 1-.233.098H9.664a.32.32 0 0 1-.234-.098.32.32 0 0 1-.099-.235v-6.323H26.64v6.324zm0-10.318H9.33v-2.33a.32.32 0 0 1 .1-.234.32.32 0 0 1 .233-.099h16.642a.32.32 0 0 1 .234.099.32.32 0 0 1 .098.234v2.33z"/>
            <path d="M10.663 23.012h2.663v1.331h-2.663zM14.657 23.012h3.994v1.331h-3.994z"/>
        </g>
    </g>
</svg>


</template>
<script>
export default {
	name: 'card-svg',
};
</script>




// WEBPACK FOOTER //
// cardSvg.vue?3d15c746